import { render, staticRenderFns } from "./BalanceChangeRequestEditor.vue?vue&type=template&id=bece7786&"
import script from "./BalanceChangeRequestEditor.vue?vue&type=script&lang=js&"
export * from "./BalanceChangeRequestEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports